export const enterKeyPressHandler = (e) => e.key === 'Enter';
export const isEscapeKeyEvent = (e) => e.key === 'Escape';
